export const colors = {
  white: "#ffffff",
  black: "#333",
  sky: { dark: "#d0dfecad", light: "#dceaf7ad" },
  red: { dark: "#7e2b3b", light: "#bf485e" },
  green: { dark: "#16635c", light: "#3b9188" },
  navy: { dark: "#101c30", light: "#17243d" },
  // navy: { dark: "#141e2f", light: "#132342" },
  // navy: { dark: "#121212", light: "#1F1F1F" },
  blue: { dark: "#205aaa", light: "#3488fc" },
  orange: { dark: "#8d671b", light: "#ce9d14" },
  darkGray: { dark: "#34495E", light: "#40617e" },
  lightGray: { dark: "#BEC3C7", light: "#EBF1F1" },
};
